import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh = { 
	messages:{
		//Customer.vue
		customer_new:'新建',
		customer_edit:'编辑',
		customer_delete:'删除',
		customer_import:'导入',
		customer_country:'国家/地区',
		customer_city:'城市',
		customer_companyName:'公司名称',
		customer_search:'搜索',
		customer_webPage:'首页',
		customer_email:'邮箱',
		customer_phone:'电话',
		customer_address:'地址',
		customer_language:'语言',
		customer_personInCharge:'负责人',
		customer_nature:'企业性质',
		customer_remark:'备注',
		customer_historyMask:'历史任务',
		customer_customerInfo:'客户信息',
		customer_cancel:'取消',
		customer_save:'保存',
		customer_sure:'确定',
		customer_deleteTip:'此操作将永久删除该潜在客户信息，是否继续？',
		customer_customerRegion:'客户区域',
		customer_importFile:'导入文件',
		customer_browse:'浏览',
		//Info.vue
		info_basicInfo:'基本信息',
		info_saleMan:'营销人员（人）',
		info_potentialCustomer:'潜在客户（个）',
		info_sentMailCustomer:'已发送邮件客户（件）',
		info_mailNum:'总邮件数（件）',
		info_dialedPhone:'已拨打电话（个）',
		info_allPhone:'总电话数（个）',
		info_potentialCustomerStatus:'潜在客户状态',
		info_noFeedback:'无反馈',
		info_downLoaded:'已下载',
		info_registered:'已注册',
		info_activated:'已激活',
		//Left.vue
		left_index:'首页',
		left_potentialCustomer:'潜在客户',
		left_saleMan:'营销人员',
		left_mask:'任务',
		//Login.vue
		login_email:'电子邮箱',
		login_password:'账号密码',
		login_identifyCode:'验证码',
		login_forgetPassword:'忘记密码？',
		login_login:'登录',
		login_mail:'邮箱地址',
		login_pass:'密码',
		login_repass:'确认密码',
		login_idenCode:'验证码',
		login_oldPass:'旧密码',
		login_resetCode:'重置码',
		login_inputMail:'请输入邮箱',
		login_inputPass:'请输入密码',
		login_inputIdenCode:'请输入验证码',
		login_codeNeedSix:'验证码必须为6位！',
		login_codeError:'验证码错误！',
		login_inputEmail:'请输入邮箱',
		//SalesPerson.vue
		salesPerson_new:'新建',
		salesPerson_detail:'详细',
		salesPerson_delete:'删除',
		salesPerson_country:'国家/地区',
		salesPerson_city:'城市',
		salesPerson_name:'姓名',
		salesPerson_whosCountry:'负责国家/地区',
		salesPerson_whosCity:'负责城市',
		salesPerson_search:'搜索',
		salesPerson_phone:'电话',
		salesPerson_email:'个人邮箱',
		salesPerson_olandEmail:'oland邮箱',
		salesPerson_liveCountry:'居住国家/地区',
		salesPerson_livecity:'居住城市',
		salesPerson_liveAddress:'居住地址',
		salesPerson_motherLang:'母语',
		salesPerson_IDtype:'证件类型',
		salesPerson_IDnum:'证件号',
		salesPerson_bank:'银行',
		salesPerson_bankAccount:'银行帐号',
		salesPerson_company:'单位',
		salesPerson_taskCount:'任务数',
		salesPerson_personalInfo:'个人信息',
		salesPerson_IDnumber:'证件号码',
		salesPerson_address:'地址',
		salesPerson_maskStatistic:'任务统计',
		salesPerson_maskCount:'任务数',
		salesPerson_potentitalcustomerStatusNum:'潜在客户状态数：',
		salesPerson_dialedPhone:'拨打电话数',
		salesPerson_noFeedback:'无反馈',
		salesPerson_downloaded:'已下载',
		salesPerson_sentEmailNum:'发送邮件数',
		salesPerson_registered:'已注册',
		salesPerson_activated:'已激活',
		salesPerson_edit:'编辑',
		salesPerson_cancel:'取消',
		salesPerson_save:'保存',
		salesPerson_sure:'确定',
		salesPerson_deleteTip:'此操作将永久删除该人员信息，是否继续？',
		//Top.vue
		top_img:'用户图像',
		top_logOff:'注销',
	},
	...zhLocale
}
export default zh


// WEBPACK FOOTER //
// ./src/common/lang/zh.js